import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { ProductCard } from '@/components/ProductCard';
import { Visibility } from '@/components/Visibility';
export const Wrapper = styled(Box)<{ variant: string }>`
  height: inherit;
  ${({ theme, variant }) => css`
    ${variant === 'Squared' &&
    css`
      aspect-ratio: 1;
      overflow: hidden;
    `}

    .trending-now {
      opacity: 0;
      transition: opacity 0.2s ease;
      ${theme.media.sm.down} {
        opacity: 1;
      }
    }
    &:hover {
      .trending-now {
        opacity: 1;
      }
    }
  `};
`;

export const ProductImage = styled(ProductCard.Image)<{ variant: string }>`
  ${({ variant }) => css`
    ${variant === 'Squared' &&
    css`
      && {
        width: auto;
        height: 100%;
        > .next-image {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
    `}
  `};
`;

export const ProductAlternateImgImage = styled(ProductCard.AlternateImg)<{
  variant: string;
}>`
  ${({ variant }) => css`
    ${variant === 'Squared' &&
    css`
      && {
        width: auto;
        height: 100%;
        > .next-image {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
    `}
  `};
`;

export const ProductSlider = styled(ProductCard.Slider)<{
  variant: string;
}>`
  ${({ variant }) => css`
    ${variant === 'Squared' &&
    css`
      && {
        aspect-ratio: 1;
        width: auto;
        height: 100%;
        .next-image {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
    `}
  `};
`;

export const VisibilityWrapper = styled(Visibility)`
  width: auto;
`;

export const ProductCardDetails = styled(ProductCard.Details)<{
  gap?: number;
}>`
  ${({ gap, theme }) => css`
    && {
      flex: 1;
      min-height: unset;
      button {
        margin-top: calc(
          ${theme.spacing(2)} - ${gap ?? 0}px
        ); //remove gap height
      }
    }
  `};
`;

export const ProductCardWrapper = styled(ProductCard)<{ $variant: string }>`
  height: 100%;
  ${({ $variant }) => css`
    ${$variant === 'Squared' &&
    css`
      height: 100%;
    `}
  `};
`;

export const ProductCardName = styled(ProductCard.Name)`
  flex: 1;
`;
